<template>
     <section class="login-content">
         <div class="container h-100">
            <div class="row justify-content-center align-items-center height-self-center">
               <div class="col-md-5 col-sm-12 col-12 align-self-center">
                  <div class="sign-user_card">
                        <img src="@/assets/images/NS_Black_cleaned.svg" class="img-fluid rounded-normal light-logo logo" alt="logo">
                     
                     <h3 class="mb-3">Log In</h3>
                     <p>Login to stay connected.</p>
                     <!-- <div class="row p-0 m-0 col-12 justify-content-end mb-2">
                        <small><a href="javascript:void(0)" v-on:click="guestLogin" class="btn-link mx-2 float-right">Log In as Guest</a></small>
                     </div> -->
                     <form @submit.prevent="onSubmit()">
                        <div class="row">
                           <div class="col-lg-12">
                              <div class="floating-label form-group">
                                 <input class="floating-input form-control" v-model="merchant_code" type="text" placeholder=" Merchant Code ">
                                 
                              </div>
                           </div>
                           <div class="col-lg-12">
                              <div class="floating-label form-group">
                                 <input class="floating-input form-control" v-model="username" type="text" placeholder=" Username ">                                 
                              </div>
                           </div>
                           <div class="col-lg-12">
                              <div class="floating-label form-group">
                                 <input class="floating-input form-control" v-model="password" type="password" placeholder=" Password ">
                                 
                              </div>
                           </div>
                     
                        </div>

                        <div class="row justify-content-center align-items-center">
                           <button type="submit" class="btn btn-primary mx-2">Log In</button>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </section>
</template>
<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
const URL = require("../../../../config");
Vue.use(VueAxios, axios)

export default {
    name:'SignIn',
    data(){
       return{
         username: "",
         merchant_code: "",
         password: ""
       }
         
    },
    methods: {
      async onSubmit () {
         try {
            const response = await axios.post(URL.api.URL + '/api/login', {
               username: this.username,
               merchant_code: this.merchant_code,
               password: this.password
            },
            { params: { m: this.$route.meta.uid } });

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));

            if (response.data.token != null) {
               this.$router.push({path: '/'});
            } 
            else {
               alert("Wrong username or password or merchant code");
            }
         } catch(error) {
            alert("Login error");
            console.log("Error: ", error);
         }
      },
      // async guestLogin() {
      //    try {
      //       const response = await axios.post(URL.api.URL + '/api/login', {
      //          username: 'guest',
      //          merchant_code: '-',
      //          password: 'guest'
      //       },
      //       { params: {} });

      //       if (response.data.token) {
      //          localStorage.setItem('token', response.data.token);
      //          localStorage.setItem('user', JSON.stringify(response.data.user));
      //          this.$router.push({path: '/'}).catch(err => {console.log(err)});
      //       } 
      //       else {
      //          alert("Wrong username or password or merchant code");
      //       }
      //    } catch(error) {
      //       console.log("Error: ", error);
      //    }
      // }
   }  
}
</script>